import React, { useEffect, useCallback } from 'react';
import T from 'prop-types';
import { map, includes } from 'lodash-es';

import SearchTypeahead from '../../../../../components/SearchTypeahead';

const placeholderStepText = ['your first', 'a second', 'a third', 'a fourth', 'a fifth', 'a fifth'];

const AddAppComponent = ({
  selectedApps,
  selectionForbidden,
  searchTypeaheadMobileRef,
  onChange,
  onForbiddenStatusChange,
  onBlur,
  onFocus,
}) => {
  const searchTypeaheadMobile = useCallback(() =>
    searchTypeaheadMobileRef && searchTypeaheadMobileRef.current.typeaheadInstance(),
  []);

  const clearTypeahed = () => {
    searchTypeaheadMobileRef.current.setState({ searchResults: [] });
    if (searchTypeaheadMobile) {
      searchTypeaheadMobile().clear();
      searchTypeaheadMobile().setState({ text: '' });
    }
  };

  const handleAppSelect = useCallback((app) => {
    if (!app) return;
    onChange((prevApps) => {
      if (!prevApps.some(({ ref_no }) => `${ref_no}` === `${app.ref_no}`) && prevApps.length < 5) {
        return [...prevApps, app];
      }
      return prevApps;
    });
  }, []);

  // Search
  const handleChange = useCallback(([app]) => {
    handleAppSelect(app);
    if (!includes(map(selectedApps, 'ref_no'), app.ref_no) && selectedApps.length < 5) {
      clearTypeahed();
    }
  }, [handleAppSelect]);

  const handleItemSelected = useCallback(app => ({
    itemSelected: app.dls_30d === 0 || includes(map(selectedApps, 'ref_no'), app.ref_no),
  }), [selectedApps]);

  const handleSearch = useCallback((results, searchQuery, forbidden) => {
    if (!selectionForbidden && forbidden) onForbiddenStatusChange(forbidden);
  }, [onForbiddenStatusChange]);

  const filterSearchResults = useCallback(results => results.filter(app => app.dls_30d !== 0), []);

  const placeholderText = `Search to add ${placeholderStepText[selectedApps.length]} app`;

  return (
    <section className="add-app-mobile__body">
      <div className="add-app-mobile__search">
        <SearchTypeahead
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
          onSearchCallback={handleSearch}
          itemSelected={handleItemSelected}
          decorateItems={filterSearchResults}
          ref={searchTypeaheadMobileRef}
          searchAsset="apps"
          assets={['apps']}
          maxHeight="154px"
          placeholder={placeholderText}
          decorators={['dls_30d', 'big_icon_url']}
          disabled={selectionForbidden}
          minLength={1}
          disableSearchOnFocus
          disableRecentResults
          includesUnified
        />
      </div>
    </section>
  );
};

AddAppComponent.propTypes = {
  selectedApps: T.array.isRequired,
  selectionForbidden: T.bool.isRequired,
  searchTypeaheadMobileRef: T.object.isRequired,
  onChange: T.func.isRequired,
  onForbiddenStatusChange: T.func.isRequired,
  onBlur: T.func,
  onFocus: T.func,
};

export default AddAppComponent;
